import React, {Component} from 'react';
import {Alert, Button, ButtonGroup, Col, FormControl, FormGroup, Row} from "react-bootstrap";
import FieldGroup from "../FieldGroup";
import {saveLanguage, getLanguage} from "../../redux/actions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {CREATE_MODE, EDIT_MODE, VIEW_MODE} from "../constants";
import ControlLabel from "react-bootstrap/es/ControlLabel";

import {authorised} from "../layout/authorised";

class LanguageDetails extends Component {
    constructor(props) {
        super(props);
        console.log("Loading Language Details for ", props.match.params.id);
        this.state = {
            mode: typeof props.mode !== "undefined" ? props.mode : VIEW_MODE,
            language: typeof this.props.language !== "undefined" ? this.props.language : {
                languageCode: "",
                master: false,
                base: false,
                active: true,
                customerId: "", // "" means nothing in our situation, the component requires a value...
                translations: {}
            }
        };

    }

    componentDidMount() {
        if (this.state.mode !== CREATE_MODE) {
            this.setState({loadingLanguage: true, language:undefined});
            this.props.dispatch(getLanguage(this.props.match.params.id))
        }
    }

    componentDidUpdate() {
        if(this.props.pendingCalls === 0) {
            if (this.state.loadingLanguage && this.props.language) {
                console.log("loaded", this.props.language);
                this.setState({language: this.props.language, loadingLanguage: false})
            }

            if (this.state.saving === true) {
                // Check if there was an error.
                this.setState({saving: false});
                if (!this.props.error) {
                    this.setState({language: undefined});
                    this.props.history.push('/i18n')
                }
            }
        }
    }

    languageCodeChanged(e) {
        this.setState({
            language: {
                ...this.state.language,
                languageCode: e.target.value
            },
            error: undefined
        });
    }

    customerIdChanged(e) {
        let v = e.target.value;

        if(v === "") v = undefined; // remove the empty id for the api call

        this.setState({
            language: {
                ...this.state.language,
                customerId: v
            },
            error: undefined
        });
    }

    activeChanged(e) {
        this.setState({
            language: {
                ...this.state.language,
                active: e.target.checked
            },
            error: undefined
        });
    }

    masterChanged(e) {
        this.setState({
            language: {
                ...this.state.language,
                master: e.target.checked
            },
            error: undefined
        });
    }

    baseChanged(e) {
        this.setState({
            language: {
                ...this.state.language,
                base: e.target.checked
            },
            error: undefined
        });
    }

    isDisabled() {
        return this.state.mode === VIEW_MODE;
    }

    startEdit(e) {
        e.preventDefault();
        this.setState({mode: EDIT_MODE});
    }

    loginOnPrivateCore(e) {
        e.preventDefault();
        this.props.history.push('/languages/' + this.props.match.params.id + "/login");
    }

    goToPrivateCore(e) {
        e.preventDefault();
        this.props.history.push('/languages/' + this.props.match.params.id + "/private");
    }

    updateLanguage(e) {
        this.setState({saving: true});
        e.preventDefault();
        this.props.dispatch(saveLanguage({language: this.state.language, mode: this.state.mode}));
    }

    renderPrivateServerUrl(customer) {
        return (customer.configuration.privateCore.httpsEnabled ? "https://" : "http://") + customer.configuration.privateCore.dns
    }

    render() {
        return (
            <div>
                <Row className="show-grid">
                    <Col xsHidden={true} smHidden={true} md={3} lg={4}/>
                    <Col xs={12} sm={12} md={6} lg={4}>
                        <h2>{this.state.language ? this.state.language.languageCode : null} </h2>
                        {this.state.language ? <form>
                            <FieldGroup
                                value={this.state.language.languageCode}
                                id="language_code"
                                type="text"
                                disabled={this.isDisabled()}
                                onChange={e => this.languageCodeChanged(e)}
                                label="Language code"
                                placeholder="Language name"
                            />

                            <FormGroup controlId="formControlsSelect">
                                <ControlLabel>Customer</ControlLabel>
                                <FormControl componentClass="select"
                                             value={this.state.language.customerId}
                                             onChange={e => this.customerIdChanged(e)}
                                             disabled={this.isDisabled()}>
                                    <option value=""/>
                                    {this.props.customers && this.props.customers.map((customer, index) => {
                                        return (<option key={customer.id} value={customer.id}>{customer.name} - {this.renderPrivateServerUrl(customer)}</option>)
                                    })}
                                </FormControl>
                            </FormGroup>

                            <FieldGroup
                                checked={this.state.language.active}
                                id="language_active"
                                type="checkbox"
                                disabled={this.isDisabled()}
                                onChange={e => this.activeChanged(e)}
                                label="Active"
                            />

                            <FieldGroup
                                checked={this.state.language.master}
                                id="language_master"
                                type="checkbox"
                                disabled={this.isDisabled()}
                                onChange={e => this.masterChanged(e)}
                                label="Master language"
                            />

                            <FieldGroup
                                checked={this.state.language.base}
                                id="language_base"
                                type="checkbox"
                                disabled={this.isDisabled()}
                                onChange={e => this.baseChanged(e)}
                                label="Base language"
                            />

                            {typeof this.props.error !== 'undefined' ?
                                <Alert bsStyle="danger">
                                    {this.props.error}
                                </Alert> : null}

                            {this.isDisabled() ?
                                <ButtonGroup>
                                    <Button onClick={e => this.startEdit(e)}>Edit</Button>
                                </ButtonGroup>
                                :
                                <Button block={true} disabled={this.props.pendingCalls > 0}
                                        onClick={e => this.updateLanguage(e)} bsStyle="primary"
                                        type="submit">Save</Button>}

                        </form> : null}
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.currentLanguage,
        pendingCalls: state.pendingCalls,
        error: state.lastError,
        privateCoreJwt: state.privateCoreJwt,
        customers: state.customers
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(authorised(LanguageDetails)));



// WEBPACK FOOTER //
// ./src/components/languages/LanguageDetails.js